import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from './User';

export interface AuthFacadeContract {
  user$: Observable<User>;
  loaded$: Observable<boolean>;
  loadUser(): Observable<User>;
  login(email: string, password: string): Observable<User>;
  loginWithGoogle(): Observable<User>;
  logout(): void;
}

export const AUTH_FACADE = new InjectionToken<AuthFacadeContract>('AUTH_FACADE');
